module.exports = __webpack_public_path__ + "static/media/fossil_brush.396e1b0a.cur";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/cursors/fossil_brush.cur
// module id = 2613
// module chunks = 0